import layoutComponents from "../../secrets-web/src/components/layout";

import DropdownMenu from "./DropdownMenu";

layoutComponents.DropdownMenu = DropdownMenu;

export default layoutComponents;